<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .dialler-body {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    position: relative;
  }
</style>

<script>
  import { diallerState } from "../diallerState.svelte";
  import AddTeammateView from "../views/AddTeammateView.svelte";
  import InboundCallView from "../views/InboundCallView.svelte";
  import InviteView from "../views/InviteView.svelte";
  import KeypadDialView from "../views/KeypadDialView.svelte";
  import KeypadView from "../views/KeypadView.svelte";
  import ManagerView from "../views/ManagerView.svelte";
  import OutcomeView from "../views/OutcomeView.svelte";
  import SaveContactView from "../views/SaveContactView.svelte";
  import UserView from "../views/UserView.svelte";
  import SaveContactNotification from "./SaveContactNotification.svelte";
  let viewMode = $derived(diallerState.viewMode);
</script>

<div class="dialler-body">
  <SaveContactNotification />

  {#if viewMode === "outcome"}
    <OutcomeView />
  {:else if viewMode === "keypad-dial"}
    <KeypadDialView />
  {:else if viewMode === "inbound-call"}
    <InboundCallView />
  {:else if viewMode === "keypad"}
    <KeypadView />
  {:else if viewMode === "addTeammate"}
    <AddTeammateView />
  {:else if viewMode === "invite"}
    <InviteView />
  {:else if viewMode === "manager"}
    <ManagerView />
  {:else if viewMode === "saveContact"}
    <SaveContactView />
  {:else}
    <UserView />
  {/if}
</div>
